import SMessage from './SMessage.vue';
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';

const MessageConstructor = Vue.extend(SMessage);

const Message: IMessage = (message, propsData = {}) => {
  propsData.message = message;
  propsData.id = Message.id++;
  propsData.onClose = Message.close;
  const instance = (new MessageConstructor({
    propsData,
  }) as IMessageComponent);

  instance.$mount();
  const el = document.getElementById('message');
  if (el) el.appendChild(instance.$el);
  Message.instances.push(instance);

  return instance;
};

// eslint-disable-next-line no-array-constructor
Message.instances = [];
Message.id = 0;

Message.success = (message, options = {}) => {
  options.type = 'success';
  return Message(message, options);
};

Message.error = (message, options = {}) => {
  options.type = 'error';
  if (!options.duration) {
    options.duration = 30000; // error messages are easy to miss otherwise
  }
  return Message(message, options);
};

Message.warning = (message, options = {}) => {
  options.type = 'warning';
  return Message(message, options);
};

Message.info = (message, options = {}) => {
  options.type = 'info';
  return Message(message, options);
};

Message.close = id => {
  Message.instances = Message.instances.filter(inst => inst.id !== id);
  const instance = Message.instances.find(inst => inst.id === id);
  if (instance) instance.$destroy();
  document.querySelectorAll(`.message[data-id="${id}"`).forEach(el => el.parentNode && el.parentNode.removeChild(el));
};

export default Message;

interface IMessageOptions {
  id?: number;
  type?: string;
  duration?: number; // duration in ms, 0 for infinite
  message?: string | TranslateResult;
  title?: string | TranslateResult;
  onClose?: (id: number) => void;
}

declare class IMessageComponent extends Vue {
  public id: number;
  public close(id: number): void;
}

export interface IMessage {
  instances: IMessageComponent[];
  id: number;
  (message: string | TranslateResult | undefined, propsData?: IMessageOptions): IMessageComponent;
  success(message: string | TranslateResult | undefined, options?: IMessageOptions): IMessageComponent;
  warning(message: string | TranslateResult | undefined, options?: IMessageOptions): IMessageComponent;
  info(message: string | TranslateResult | undefined, options?: IMessageOptions): IMessageComponent;
  error(message: string | TranslateResult | undefined, options?: IMessageOptions): IMessageComponent;
  close(id: number): void;
}
